/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
import React, { useEffect, useState } from "react";
import { StyleSheet } from "react-native";
import { useDispatch, useSelector } from "react-redux";
import allActions from "../../reduxStores/actions/allActions";

// import { useDispatch, useSelector } from "react-redux";
// import allActions from "../../reduxStores/actions/allActions";
import { STACK_SCREEN, MyLog } from "../../constants/config";

// import { WebView } from "react-native-webview";

const redirectGoogleLogin = () => {
  MyLog("redirectGoogleLogin googleProvider");
};

// https://6c0b-121-98-61-200.ngrok.io/connect/google/callback?code=4/0AX4XfWjTUI5yhQp_g2OqgJKh1ucXWjJLJZMFH_LT64uB1ok4PylPyO1kiJqvLvLdY3Dgow&scope=email openid https://www.googleapis.com/auth/userinfo.email&authuser=0&prompt=none
// 302 redirect to below url:
// http://localhost:3001/connect/google/redirect?id_token=eyJhbGciOiJSUzI1NiIsImtpZCI6ImJiZDJhYzdjNGM1ZWI4YWRjOGVlZmZiYzhmNWEyZGQ2Y2Y3NTQ1ZTQiLCJ0eXAiOiJKV1QifQ.eyJpc3MiOiJhY2NvdW50cy5nb29nbGUuY29tIiwiYXpwIjoiMTgyNzQxODI3NzE5LWxscXVpYnBlZHRqaHMxNmxmdGsxcThoc2I0amtwY3JiLmFwcHMuZ29vZ2xldXNlcmNvbnRlbnQuY29tIiwiYXVkIjoiMTgyNzQxODI3NzE5LWxscXVpYnBlZHRqaHMxNmxmdGsxcThoc2I0amtwY3JiLmFwcHMuZ29vZ2xldXNlcmNvbnRlbnQuY29tIiwic3ViIjoiMTAzNDk4MTkzMTU1MjU3ODk4MzU3IiwiZW1haWwiOiJndW93YWl2cHNAZ21haWwuY29tIiwiZW1haWxfdmVyaWZpZWQiOnRydWUsImF0X2hhc2giOiJhX3pNTm1iaTdKTDN2MC04MXkyYmNRIiwiaWF0IjoxNjM1NDgzMjI1LCJleHAiOjE2MzU0ODY4MjV9.WT-S0WmEPucL9BfC_0FXzXOZ2d9uNSfNcZHYPmSBZ8TD1T-5J-6dR-C-ZLpDe9FGB0lpugQOofAcw5WdPkhu_Lf6IuUcXpSl6CVOV_QQ9pPv3Ac43QK-TA0NxIMeBXoBo9m46S-laJ8B_kXef_dLRZ1zkZRJSJ6HkAjkS0hOTqQfrlHp55-jiznr0fMxWXPOtdvz9QoaiNoYRAq5nfOBotgLwqMSQFir2pn9L8OQP5OFhR90lwDOSviYSIHtQIH37-zOiXCF7k9OKPHnsTkRpO9pNg-b1zYyMPVPVGmWckL8lDUzStqlzX0K7G3U7LQGeJmNre2U5ORZFVjey8yrlQ&access_token=ya29.a0ARrdaM-2-ew6aYfVYbhNfb7azxt-RglP149MqhbdBHz8df2DYxz04AZWHpsClpsv-rcxPc4AGk6FYCtce1xHHC3wHjgEXIRGk-83-S9AMcWh43XHSo2lQr7QZnVscPMSTDkSp7JJfu2pkjO-wmUXzJWFHC8L&raw[access_token]=ya29.a0ARrdaM-2-ew6aYfVYbhNfb7azxt-RglP149MqhbdBHz8df2DYxz04AZWHpsClpsv-rcxPc4AGk6FYCtce1xHHC3wHjgEXIRGk-83-S9AMcWh43XHSo2lQr7QZnVscPMSTDkSp7JJfu2pkjO-wmUXzJWFHC8L&raw[expires_in]=3598&raw[scope]=https://www.googleapis.com/auth/userinfo.email openid&raw[token_type]=Bearer&raw[id_token]=eyJhbGciOiJSUzI1NiIsImtpZCI6ImJiZDJhYzdjNGM1ZWI4YWRjOGVlZmZiYzhmNWEyZGQ2Y2Y3NTQ1ZTQiLCJ0eXAiOiJKV1QifQ.eyJpc3MiOiJhY2NvdW50cy5nb29nbGUuY29tIiwiYXpwIjoiMTgyNzQxODI3NzE5LWxscXVpYnBlZHRqaHMxNmxmdGsxcThoc2I0amtwY3JiLmFwcHMuZ29vZ2xldXNlcmNvbnRlbnQuY29tIiwiYXVkIjoiMTgyNzQxODI3NzE5LWxscXVpYnBlZHRqaHMxNmxmdGsxcThoc2I0amtwY3JiLmFwcHMuZ29vZ2xldXNlcmNvbnRlbnQuY29tIiwic3ViIjoiMTAzNDk4MTkzMTU1MjU3ODk4MzU3IiwiZW1haWwiOiJndW93YWl2cHNAZ21haWwuY29tIiwiZW1haWxfdmVyaWZpZWQiOnRydWUsImF0X2hhc2giOiJhX3pNTm1iaTdKTDN2MC04MXkyYmNRIiwiaWF0IjoxNjM1NDgzMjI1LCJleHAiOjE2MzU0ODY4MjV9.WT-S0WmEPucL9BfC_0FXzXOZ2d9uNSfNcZHYPmSBZ8TD1T-5J-6dR-C-ZLpDe9FGB0lpugQOofAcw5WdPkhu_Lf6IuUcXpSl6CVOV_QQ9pPv3Ac43QK-TA0NxIMeBXoBo9m46S-laJ8B_kXef_dLRZ1zkZRJSJ6HkAjkS0hOTqQfrlHp55-jiznr0fMxWXPOtdvz9QoaiNoYRAq5nfOBotgLwqMSQFir2pn9L8OQP5OFhR90lwDOSviYSIHtQIH37-zOiXCF7k9OKPHnsTkRpO9pNg-b1zYyMPVPVGmWckL8lDUzStqlzX0K7G3U7LQGeJmNre2U5ORZFVjey8yrlQ
const UserLoginWithGoogleScreen = ({ route, navigation }) => {
  const accessToken = route.params?.access_token;
  MyLog("UserLoginWithGoogleScreen route2", route, accessToken);
  const dispatch = useDispatch();
  const formData = {
    loginType: "google",
    accessToken: accessToken,
  };
  dispatch(allActions.userLoginRequest(formData));

  return <div>Login with Google ...</div>;

  // const [auth, setAuth] = useState();
  // // const location = useLocation();
  // useEffect(() => {
  //   if (!access_token) {
  //     return;
  //   }
  //   axios({
  //     method: "GET",
  //     url: `http://localhost:9337/auth/google/callback?access_token=${access_token}`,
  //   })
  //     .then((res) => res.data)
  //     .then(setAuth);
  // }, [access_token]);

  // return (
  //   <div>
  //     <span>AUTH:</span>
  //     {auth && (
  //       <>
  //         <div>Jwt: {auth.jwt}</div>
  //         <div>User Id: {auth.user.id}</div>
  //         <div>Provider: {auth.user.provider}</div>
  //       </>
  //     )}
  //   </div>
  // );
};

// const styles = StyleSheet.create({});

export default UserLoginWithGoogleScreen;
